import { Common } from '~/models/common';

export namespace Variables {
	export const collection = 'variables';
	export const api = `/api/${collection}`;

	export type Model = Omit<Common.Model, 'sort'> & {
		name: string | null;
		value: string | null;
		description: string | null;
	};

	export const modelState: Model = {
		...Common.modelState,
		id: 0,
		name: null,
		value: null,
		description: null,
	};
}
